/*
 * Copyright (c) 2020.
 * Simon
 */

import {
    FANPAGE_GET_STARTED_STATUS_UPDATE,
    FANPAGE_GET_STARTED_STATUS_FAILURE,
} from '../../../types';

/**
 * @param {*} state
 * @param {*} action
 */
const FanpageGetStartedStatusReducer = (state = {}, action) => {
    switch (action.type) {
        case FANPAGE_GET_STARTED_STATUS_UPDATE:
        case FANPAGE_GET_STARTED_STATUS_FAILURE:
            return {
                ...state,
                data: action.payload
            };
        default:
            return state;
    }
};

export {
    FanpageGetStartedStatusReducer
}